

const StickyHeader = () => {
  const scrollToForm = () => {
    document.getElementById("hero-form")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 border-b border-border bg-background/95 backdrop-blur-md">
      <div className="container mx-auto flex h-16 items-center justify-between px-4">
        <div className="text-2xl font-extrabold tracking-tight text-primary" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
          E-forma
        </div>

        <div className="flex items-center gap-3 md:gap-4">
          <button onClick={scrollToForm} className="btn-cta-sm text-sm">
            Vérifier mon éligibilité gratuitement
          </button>
        </div>
      </div>
    </header>
  );
};

export default StickyHeader;
